import { render, staticRenderFns } from "./EventAlarmTagsTooltip.vue?vue&type=template&id=13bf3c4d"
import script from "./EventAlarmTagsTooltip.vue?vue&type=script&lang=ts"
export * from "./EventAlarmTagsTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports